<tui-root>
  @if (showRouterProgress()) {
    <progress tuiProgressBar [max]="100" size="xs"></progress>
  }
  <app-dashboard [ngClass]="{'progress': showRouterProgress()}">
    <router-outlet />
  </app-dashboard>
</tui-root>
